import React from 'react';

import { Button } from '@mui/material';

import { en } from 'localization';
import { BrandWordmark } from 'shared-components/brand';
// Concrete-module imports (not the state-views barrel) keep unrelated state
// views out of this crash surface's module graph.
import { StateAlert } from 'shared-components/state-views/state-alert';
import { StateActions } from 'shared-components/state-views/styled-components';

import {
  FallbackHeader,
  FallbackMain,
  FallbackShell,
} from './styled-components';

// Candidate-visible crash surface. Keep it dependency-light — theme, brand,
// and MUI only, no router or query hooks — so the fallback cannot crash
// itself, and never render raw error content.
export const AppErrorFallback: React.FC = () => (
  <FallbackShell>
    <FallbackHeader>
      <BrandWordmark />
    </FallbackHeader>

    <FallbackMain>
      <StateAlert
        action={
          <StateActions>
            <Button
              onClick={() => globalThis.location.reload()}
              variant="contained"
            >
              {en.appErrorBoundary.reloadAction}
            </Button>
          </StateActions>
        }
        heading={en.appErrorBoundary.heading}
        headingComponent="h1"
        headingVariant="h5"
        message={en.appErrorBoundary.message}
        severity="error"
      />
    </FallbackMain>
  </FallbackShell>
);
